import { axios } from '@/utils/request'

export function getChurchByDomain() {
    return axios.get('/medias/church')
}

export function getChannelInfo() {
    return axios.get('/lives/channel')
}
